import { useEffect, useState } from 'react';

/**
 * An element's rendered width, kept current as it resizes, and the callback ref that attaches
 * it. A callback ref rather than an object ref, because the element may mount after the
 * component does, e.g. once the days arrive. Null until measured.
 */
export function useElementWidth<T extends HTMLElement>(): [
    T | null,
    (node: T | null) => void,
    number | null,
] {
    const [node, setNode] = useState<T | null>(null);
    const [width, setWidth] = useState<number | null>(null);

    useEffect(() => {
        // jsdom has no ResizeObserver, and lays nothing out to measure.
        if (!node || typeof ResizeObserver === 'undefined') {
            return;
        }
        const observer = new ResizeObserver(([entry]) => {
            setWidth(entry ? Math.round(entry.contentRect.width) : null);
        });
        observer.observe(node);
        return () => observer.disconnect();
    }, [node]);

    return [node, setNode, width];
}
